/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';

export interface ExportStationAlarms$Any$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the alarm date
 *   * NAME : the alarm name/alias
 *   * DESCRIPTION : the alarm description
 *   * STATION : the station name
 */
  sortFieldName?: 'DATE' | 'NAME' | 'DESCRIPTION' | 'STATION';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search alarm
     */
    body?: any
}

export function exportStationAlarms$Any(http: HttpClient, rootUrl: string, params: ExportStationAlarms$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportStationAlarms$Any.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportStationAlarms$Any.PATH = '/stations/{uid}/alarms/active/export';
